import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <main className="min-h-screen grid place-items-center px-6" data-testid="notfound-page">
      <div className="text-center">
        <p className="font-display foil-text" style={{ fontSize: "clamp(4rem,14vw,9rem)", lineHeight: 1 }}>404</p>
        <p className="font-caps text-gold mt-2" style={{ fontSize: ".72rem" }}>This page isn&rsquo;t part of the record</p>
        <p className="mt-4" style={{ color: "var(--ash)" }}>The page you were looking for doesn&rsquo;t exist here.</p>
        <Link to="/" className="btn-gold mt-8 inline-flex" data-testid="notfound-home">Back to the music</Link>
      </div>
    </main>
  );
}
